import bulletinTypes from './bulletin_types.json';
import bulletins from './bulletins.json';
import intelFeed from './intel-feed.json';
import statuses from './statuses.json';

const en = {
  bulletins,
  statuses,
  bulletinTypes,
  intelFeed,
};

export default en;
